import { default as Utils } from '../utils/base.Utils.js';
export default class UtilsLanguage {
  constructor() {

  }

  //return current user language
  static getUserLanguage() {

    let y = Utils.Cookie.get(Utils.Configuration.userLanguageCookieKey);
    if (y === undefined || y === null)
      y = navigator.language ? navigator.language : navigator.userLanguage;

    let isItalian = y === "it" || y === "it-IT";
    let isEnglish = y === "en" || y === "en-US";
    let isDeutch = y === "de" || y === "de-DE";
    let isPorto = y === "pt" || y === "pt-PT" || y === "pt-BR";

    if (y === "it-IT")
      y = "it";
    if (y === "en-US")
      y = "en";
    if (y === "de-DE")
      y = "de";
    if (y === "pt-PT" || y === "pt-BR")
      y = "pt";

    if (!isItalian && !isEnglish && !isDeutch && !isPorto) {
      y = "en";
    }

    return y;
  }

  //set user language
  static setUserLanguage(lang) {
    Utils.Cookie.set(Utils.Configuration.userLanguageCookieKey, lang, { expires: 500, path: '/' });
  }

  static getDataTableCDNlanguageURL() {
    return UtilsLanguage.getUserLanguage() === "it"
      ? "https://cdn.datatables.net/plug-ins/1.10.20/i18n/Italian.json"
      : "https://cdn.datatables.net/plug-ins/1.10.20/i18n/English.json"
      
  }

}
